import { snapshot, useSnapshot } from 'valtio';
import {
  Connector,
  ConnectorFieldValue,
  ConnectorsByFamilyObject,
} from '../connectors-types';
import ConnectorsStore from '../stores/connectors-store';

export const setIsLoadingConnectors = (isLoading: boolean): void => {
  ConnectorsStore.loadingConnectors = isLoading;
};

export const setConnectors = (payload: Connector[]): void => {
  ConnectorsStore.connectors = payload;
};

export const setConnectorsByFamily = (
  payload: ConnectorsByFamilyObject[],
): void => {
  ConnectorsStore.connectorsByFamily = payload;
};

export const setFilteredConnectorsByFamily = (
  payload: ConnectorsByFamilyObject[],
): void => {
  ConnectorsStore.filteredConnectorsByFamily = payload;
};

export const updateSingleConnectorsField = (
  connectorId: string,
  fieldName: string,
  fieldValue: ConnectorFieldValue,
): void => {
  const { connectorsByFamily, filteredConnectorsByFamily } = ConnectorsStore;
  let connectorToUpdateFamily: string;
  for (const familyObject of connectorsByFamily) {
    const foundConnector = familyObject.connectors.find(
      c => c.id === connectorId,
    );
    if (!foundConnector) {
      continue;
    }
    foundConnector[fieldName] = fieldValue;
    connectorToUpdateFamily = foundConnector.family;
    break;
  }
  const familyToUpdate = filteredConnectorsByFamily.find(
    familyObject => familyObject.family === connectorToUpdateFamily,
  );
  const filteredConnectorToUpdate = familyToUpdate?.connectors.find(
    connector => connector.id === connectorId,
  );
  if (filteredConnectorToUpdate) {
    filteredConnectorToUpdate[fieldName] = fieldValue;
  }
};

export const availableConnectors = (): Connector[] => {
  const connectors = snapshot(ConnectorsStore).connectors;
  return connectors;
};

export const setSearchValue = (value: string) => {
  ConnectorsStore.searchValue = value;
};

export const useIsLoadingConnectors = () => {
  const { loadingConnectors } = useSnapshot(ConnectorsStore);
  return loadingConnectors;
};

export const setScanType = (scanType?: string) => {
  ConnectorsStore.scanType = scanType;
};

export const dismissBanner = () => {
  ConnectorsStore.connectivityBannerDismissed = true;
};
